import React from 'react';
import { useTrackingOp } from "../../../../contexts/TrackingOpContext";
import { KeyOfStep, OP_STATUS, OPERATION_TYPE } from "../../../../util/varibles/constants";
import { convertActivityLog } from "../../../../util/varibles/global";
import { IOperation2, ITreatment2 } from '../../../../util/varibles/interface';
import Icon, { ICON_NAME } from "../../../Icon";
import FreshWaterDuration from '../../_components/FreshWaterDuration';
import Header from "../../_components/Header";
import Note from "../../_components/Note";
import SortingInfo from '../../_components/SortingInfo';
import StepControl from "../../_components/StepControl";
import TabControl from "../../_components/TabControl";
import Units from "../../_components/Units";
import ActivityLogs2 from "../../ActivitiesLog/ActivityLogs2";
import stylesOp from "../style.module.scss";

const Treatment: React.FC = () => {
    const [data] = useTrackingOp(state => state.op as IOperation2<ITreatment2>);
    const [step] = useTrackingOp(state => state.step);

    if (!data) return null;

    const { status, site, tasks: operationTask, current_process } = data.operation;
    const { name: siteName = "" } = site || {}
    const { activity_log = [], } = data;
    const { key = '', unit_id = undefined, duration = 0 } = activity_log[step] || {};
    const activityLog = convertActivityLog[OPERATION_TYPE.TREATMENT](activity_log);

    return <>
        <Header icon={<Icon icon={ICON_NAME.TREATMENT} />}>
            <div className={[stylesOp['operation-route'], 'flex items-center'].join(' ')}>
                <span>{siteName}</span>
            </div>
        </Header>
        <TabControl>
            {[
                <div className={stylesOp['operation-info']} key='detail'>
                    <Units data={data} activityLog={activityLog} />
                    <div className={stylesOp['operation-content']}>
                        <StepControl />
                        {(status === OP_STATUS.PROCESSING && <div className={stylesOp['operation-step-content']}>
                            {key === KeyOfStep.TREATING_FRESHWATER &&
                                <FreshWaterDuration duration={duration} />}
                            {key.includes(KeyOfStep.SORTING) &&
                                <SortingInfo unit_id={unit_id} tasks={operationTask} />}
                            <Note />
                        </div>)}
                    </div>
                </div>,
                <ActivityLogs2
                    key='activity_log'
                    current_process={current_process}
                    activity_log={activityLog}
                    activity_log_root={activity_log}
                />
            ]}
        </TabControl>
    </>;
};

export default Treatment;